var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('a',{staticClass:"banner__link",attrs:{"href":_vm.link,"target":"_blank","rel":"noopener"}},[_c('img',{staticClass:"banner__img",attrs:{"src":_vm.url,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }